import {
  get as _get,
  isArray,
} from 'lodash';
import { useAppContext } from 'contexts/AppContext';
import ModalContainer from './Modal/ModalContainer';
import ModalHeader from './Modal/ModalHeader';
import ModalBody from './Modal/ModalBody';
import ProductHelper from 'helpers/ProductHelper';
import { ChangeEvent, useEffect, useState } from 'react';
import FillButton from './Button/FillButton';
import { FaSpinner } from 'react-icons/fa';

export const backingProducts = _get(window, 'compatioConfig.compatibleProducts.backingData')
    
const optionData = _get(
  window,
  'compatioConfig.compatibleProducts.optionsData'
);
const BackingDataModal = ({
}) => {
    const {
      cart,
      dataLoading,
      isBackingModelOpen,
      backingDataInfo,
      setIsBackingModelOpen,
      setBackingDataInfo
    } = useAppContext()

    const [localBackingData, setLocalBackingData] = useState<{
        [x: string]: string;
    }|undefined>(undefined)

    useEffect(() => {
        isArray(optionData) && optionData.length > 0 && setLocalBackingData(Object.fromEntries(optionData.reduce((acc: [string, string][], option) => {
            if(option.options[0].value) 
                acc.push([option.optionId, option.options[0].value])
            return acc
        }, [])))
    }, [isBackingModelOpen])

    const handleAddBackingData = () => {
      if(isBackingModelOpen?.callback) isBackingModelOpen.callback()
      if(localBackingData) setBackingDataInfo(localBackingData)
      setIsBackingModelOpen(undefined)
    }

    const handleOptionChange = (e: ChangeEvent<HTMLInputElement|HTMLSelectElement>) => {
        setLocalBackingData((prev) => {
            return {
                ...prev,
                [e.target.name]: e.target.value
            }
        })
    }

  const OptionData = (
    <div className="sb3-space-y-3">
      <label className="sb3-text-sm">
        Please confirm these options:
      </label>
      {optionData?.map(singleOption => {
        if (singleOption.optionType === 'radio')
          return (
            <div key={singleOption.optionId} className="xcs-option-lable sb3-space-y-3">
              <label className="sb3-text-sm">
                <strong>{singleOption.optionDescription}</strong>
              </label>
              <div className='sb3-flex sb3-flex-col sb3-space-y-3'>
                {singleOption.options.map(ol => {
                  return (
                    <label key={ol.label} className="sb3-space-x-2">
                      <input
                        type="radio"
                        name={singleOption.optionId}
                        value={ol.value}
                        checked={
                            localBackingData?.[singleOption.optionId] === ol.value
                        }
                        className='focus:sb3-outline-none'
                        onChange={handleOptionChange}
                      />
                      <span className='sb3-text-sm'>{ol.label}</span>
                    </label>
                  );
                })}
              </div>
            </div>
          );
        if (singleOption.optionType === 'dropdown')
          return (
            <div key={singleOption.optionId} className="xcs-option-lable">
              <label>
                <strong>{singleOption.optionDescription}</strong>
              </label>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                {singleOption.options.length > 1 ? (
                  <select
                    value={localBackingData?.[singleOption.optionId]}
                    onChange={handleOptionChange}
                    name={singleOption.optionId}
                  >
                    {singleOption.options.map(variantOption => (
                      <option
                        id={variantOption.value}
                        value={variantOption.value}
                        key={variantOption.value}
                        className="xrs-product__option-text"
                      >
                        {variantOption.value}
                      </option>
                    ))}
                  </select>
                ) : null}
              </div>
            </div>
          );
      })}
      <span className="sb3-flex sb3-justify-end">
        <FillButton 
        onClick={() => handleAddBackingData()}
        disabled={dataLoading}
        className={`!sb3-min-w-full !sb3-max-w-full md:!sb3-min-w-[150px] md:!sb3-max-w-min sb3-w-full sb3-rounded-md`}>
            {!dataLoading ? "Add to Outfit" : <FaSpinner/>}
        </FillButton>
      </span>
    </div>
  );

  if(!isBackingModelOpen) return

  return (
    <ModalContainer
        isOpen={!!isBackingModelOpen}
        setOpen={() => setIsBackingModelOpen(undefined)}
        width={`${Math.min(window.innerWidth, 720)}px`}
        className="sb3-backing-modal sb3-rounded-none !sb3-max-w-screen"
        forced={cart.some(product => 
            product.categoryName === "Fly Reel"
        ) && !backingDataInfo}
    >
        <ModalHeader>
            <h5 className="sb3-backing-modal-title sb3-py-2 sb3-text-xl sb3-font-semibold">{ProductHelper.getProductSecondaryTitle(isBackingModelOpen.product)}</h5>
        </ModalHeader>
        <ModalBody className="!sb3-pt-3.5">
            <div className="md:sb3-flex sb3-space-y-5 md:sb3-space-y-0 md:sb3-space-x-5">
              <div
                className='sb3-flex sb3-flex-col'
              >
                <img
                  src={
                    ProductHelper.getProductImage(isBackingModelOpen.product)
                  }
                  // Ensure HTML encoded entities display properly
                  alt={ProductHelper.getProductSecondaryTitle(isBackingModelOpen.product)}
                  className="sb3-min-w-[150px] sb3-aspect-square sb3-object-contain"
                  width="150px"
                  height="150px"
                />
              </div>
              {OptionData}
            </div>
        </ModalBody>
    </ModalContainer>
  );
};

export default BackingDataModal;
